// Generated by Melange

import * as Buhta_cabinet__BatchSignPage from "../Documents/Batches/BatchSignPage.js";
import * as Buhta_cabinet__BatchViewPage from "../Documents/Batches/BatchViewPage.js";
import * as Buhta_cabinet__BatchesPage from "../Documents/Batches/BatchesPage.js";
import * as Buhta_cabinet__CashboxPage from "../Kassa/CashboxPage.js";
import * as Buhta_cabinet__ContractCreatePage from "../Documents/ContractCreatePage.js";
import * as Buhta_cabinet__ContractsPage from "../Documents/ContractsPage.js";
import * as Buhta_cabinet__CreateContractorPage from "../Manage/CreateContractorPage.js";
import * as Buhta_cabinet__DashboardTemplate from "../../templates/DashboardTemplate.js";
import * as Buhta_cabinet__HrmEmployeeFormPage from "../Hrm/HrmEmployeeFormPage.js";
import * as Buhta_cabinet__HrmEmployeePage from "../Hrm/HrmEmployeePage.js";
import * as Buhta_cabinet__HrmEmployeesPage from "../Hrm/HrmEmployeesPage.js";
import * as Buhta_cabinet__Kkm from "../../models/Kkm.js";
import * as Buhta_cabinet__KkmCreatePage from "../Kassa/KkmCreatePage.js";
import * as Buhta_cabinet__KkmJournalPage from "../Kassa/KkmJournalPage.js";
import * as Buhta_cabinet__KkmLinkPage from "../Kassa/KkmLinkPage.js";
import * as Buhta_cabinet__KkmRegisterPage from "../Kassa/KkmRegisterPage.js";
import * as Buhta_cabinet__KkmSettingsPage from "../Kassa/KkmSettingsPage.js";
import * as Buhta_cabinet__KkmStartPage from "../Kassa/KkmStartPage.js";
import * as Buhta_cabinet__KkmViewPage from "../Kassa/KkmViewPage.js";
import * as Buhta_cabinet__KkmsPage from "../Kassa/KkmsPage.js";
import * as Buhta_cabinet__MainPageLayout from "../MainPage/MainPageLayout.js";
import * as Buhta_cabinet__ManageContractorsPage from "../Manage/ManageContractorsPage.js";
import * as Buhta_cabinet__ManageProductsPage from "../Manage/ManageProductsPage.js";
import * as Buhta_cabinet__OrgSettingsPage from "../Settings/OrgSettingsPage.js";
import * as Buhta_cabinet__PayoutPage from "../Payroll/PayoutPage.js";
import * as Buhta_cabinet__PayoutsPage from "../Payroll/PayoutsPage.js";
import * as Buhta_cabinet__ReceiptsPage from "../Kassa/ReceiptsPage.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__Sidebar from "../../components/molecules/Sidebar/Sidebar.js";
import * as Buhta_cabinet__SidebarMobile from "../../components/molecules/Sidebar/SidebarMobile.js";
import * as Buhta_cabinet__TaxPaymentsOrdersCheckout from "../../components/organisms/Taxes/PaymentsTaxes/TaxPaymentsOrdersCheckout.js";
import * as Buhta_cabinet__TaxPaymentsOrdersNewEmployee from "../../components/organisms/Taxes/PaymentsTaxes/TaxPaymentsOrdersNewEmployee.js";
import * as Buhta_cabinet__TaxPaymentsOrdersNewEmployeeFull from "../../components/organisms/Taxes/PaymentsTaxes/TaxPaymentsOrdersNewEmployeeFull.js";
import * as Buhta_cabinet__TaxPaymentsOrdersPage from "../Taxes/TaxPaymentsOrdersPage.js";
import * as Buhta_cabinet__TaxPaymentsPage from "../Taxes/TaxPaymentsPage.js";
import * as Buhta_cabinet__TaxPaymentsSettingsPage from "../Taxes/TaxPaymentsSettingsPage.js";
import * as Buhta_cabinet__TaxSettingsPage from "../Taxes/TaxSettingsPage.js";
import * as Buhta_cabinet__UpdateContractorPage from "../Manage/UpdateContractorPage.js";
import * as Buhta_cabinet__ViewContractorPage from "../Manage/ViewContractorPage.js";
import * as Buhta_conf__Config from "../../../../../packages/conf/lib/Config.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(org) {
  return function (route) {
    const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
    const deviceType = state.deviceType;
    const match = React.useState(function () {
          return false;
        });
    const setMobileMenuOpen = match[1];
    const cfg = Buhta_conf__Config.getConfig(undefined);
    const appMode = cfg.app_mode;
    const match$1 = Buhta_core__Tenant.useTenant(undefined);
    const dispatchTenantCtx = match$1[1];
    const tenant = match$1[0];
    React.useEffect((function () {
            if (tenant.ctx === /* AdminCtx */1 && tenant.org.id !== org.id) {
              Curry._1(dispatchTenantCtx, {
                    TAG: /* OperatorOrgChanged */3,
                    _0: tenant.operator,
                    _1: org
                  });
            }
            
          }), [org.id]);
    const contextRoute = function (route) {
      return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
    };
    const sidebarItems_0 = {
      label: "Главная",
      route: contextRoute(/* Dashboard */0),
      isActiveRoute: (function (param) {
          if (typeof param === "number" && !param) {
            return true;
          } else {
            return false;
          }
        }),
      eventName: "",
      bar: "main",
      isHidden: false
    };
    const sidebarItems_1 = {
      hd: {
        label: "Документы",
        route: contextRoute({
              TAG: /* Documents */1,
              _0: {
                TAG: /* Batches */6,
                _0: /* List */0
              }
            }),
        isActiveRoute: (function (param) {
            if (typeof param === "number" || param.TAG !== /* Documents */1) {
              return false;
            } else {
              return true;
            }
          }),
        eventName: "",
        bar: "documents",
        isHidden: false
      },
      tl: {
        hd: {
          label: "Справочник",
          route: contextRoute({
                TAG: /* Manage */7,
                _0: /* Contractors */{
                  _0: /* List */0
                }
              }),
          isActiveRoute: (function (param) {
              if (typeof param === "number" || param.TAG !== /* Manage */7) {
                return false;
              } else {
                return true;
              }
            }),
          eventName: "",
          bar: "manage",
          isHidden: false
        },
        tl: {
          hd: {
            label: "Касса",
            route: contextRoute({
                  TAG: /* Kassa */2,
                  _0: /* Kkms */{
                    _0: /* List */1
                  }
                }),
            isActiveRoute: (function (param) {
                if (typeof param === "number" || param.TAG !== /* Kassa */2) {
                  return false;
                } else {
                  return true;
                }
              }),
            eventName: "kassa",
            bar: "kassa",
            isHidden: false
          },
          tl: {
            hd: {
              label: "Кадры",
              route: contextRoute({
                    TAG: /* Hrm */5,
                    _0: /* Employees */{
                      _0: /* Index */0
                    }
                  }),
              isActiveRoute: (function (param) {
                  if (typeof param === "number" || param.TAG !== /* Hrm */5) {
                    return false;
                  } else {
                    return true;
                  }
                }),
              eventName: "",
              bar: "hrm",
              isHidden: false
            },
            tl: {
              hd: {
                label: "Зарплата",
                route: contextRoute({
                      TAG: /* Payroll */6,
                      _0: {
                        TAG: /* Payouts */1,
                        _0: /* List */0
                      }
                    }),
                isActiveRoute: (function (param) {
                    if (typeof param === "number" || param.TAG !== /* Payroll */6) {
                      return false;
                    } else {
                      return true;
                    }
                  }),
                eventName: "",
                bar: "payroll",
                isHidden: false
              },
              tl: {
                hd: {
                  label: "Налоги",
                  route: contextRoute({
                        TAG: /* Tax */4,
                        _0: {
                          TAG: /* Payments */0,
                          _0: /* Index */0
                        }
                      }),
                  isActiveRoute: (function (param) {
                      if (typeof param === "number" || param.TAG !== /* Tax */4) {
                        return false;
                      } else {
                        return true;
                      }
                    }),
                  eventName: "",
                  bar: "taxes",
                  isHidden: appMode === "live"
                },
                tl: /* [] */0
              }
            }
          }
        }
      }
    };
    const sidebarItems = {
      hd: sidebarItems_0,
      tl: sidebarItems_1
    };
    const sidebar = deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__SidebarMobile.make, {
            org: org,
            isOpen: match[0],
            onClose: (function (param) {
                Curry._1(setMobileMenuOpen, (function (param) {
                        return false;
                      }));
              }),
            sidebarItems: sidebarItems
          }) : JsxRuntime.jsx(Buhta_cabinet__Sidebar.make, {
            org: org,
            sidebarItems: sidebarItems
          });
    const value = Buhta_cabinet__Kkm.KkmsCtx.useKkms(/* [] */0);
    const openMenu = function (param) {
      Curry._1(setMobileMenuOpen, (function (param) {
              return true;
            }));
    };
    let tmp;
    if (typeof route === "number") {
      tmp = route === /* Dashboard */0 ? JsxRuntime.jsx(Buhta_cabinet__MainPageLayout.make, {
              org: org,
              openMenu: openMenu
            }) : "Страница не найдена";
    } else {
      switch (route.TAG | 0) {
        case /* Documents */1 :
            const match$2 = route._0;
            if (typeof match$2 === "number") {
              tmp = "Страница не найдена";
            } else {
              switch (match$2.TAG | 0) {
                case /* Contracts */0 :
                    let tmp$1 = match$2._0;
                    tmp = typeof tmp$1 === "number" ? (
                        tmp$1 === /* List */0 ? JsxRuntime.jsx(Buhta_cabinet__ContractsPage.make, {
                                org: org
                              }) : JsxRuntime.jsx(Buhta_cabinet__ContractCreatePage.make, {
                                org: org
                              })
                      ) : (
                        tmp$1.TAG === /* View */0 ? JsxRuntime.jsx(Buhta_cabinet__ContractsPage.make, {
                                org: org
                              }) : "Страница не найдена"
                      );
                    break;
                case /* Batches */6 :
                    const id = match$2._0;
                    tmp = typeof id === "number" ? JsxRuntime.jsx(Buhta_cabinet__BatchesPage.make, {
                            org: org
                          }) : (
                        id.TAG === /* View */0 ? JsxRuntime.jsx(Buhta_cabinet__BatchViewPage.make, {
                                org: org,
                                id: id._0
                              }) : JsxRuntime.jsx(Buhta_cabinet__BatchSignPage.make, {
                                org: org,
                                id: id._0
                              })
                      );
                    break;
                default:
                  tmp = "Страница не найдена";
              }
            }
            break;
        case /* Kassa */2 :
            const match$3 = route._0._0;
            if (typeof match$3 === "number") {
              tmp = match$3 ? JsxRuntime.jsx(Buhta_cabinet__KkmsPage.make, {
                      org: org,
                      openMenu: openMenu
                    }) : JsxRuntime.jsx(Buhta_cabinet__KkmCreatePage.make, {
                      org: org,
                      openMenu: openMenu
                    });
            } else {
              const tab = match$3._1;
              const id$1 = match$3._0;
              if (typeof tab === "number") {
                switch (tab) {
                  case /* Start */0 :
                      tmp = JsxRuntime.jsx(Buhta_cabinet__KkmStartPage.make, {
                            org: org,
                            id: id$1,
                            openMenu: openMenu
                          });
                      break;
                  case /* Register */1 :
                      tmp = JsxRuntime.jsx(Buhta_cabinet__KkmRegisterPage.make, {
                            org: org,
                            id: id$1,
                            openMenu: openMenu
                          });
                      break;
                  case /* Link */2 :
                      tmp = JsxRuntime.jsx(Buhta_cabinet__KkmLinkPage.make, {
                            org: org,
                            id: id$1,
                            openMenu: openMenu
                          });
                      break;
                  case /* View */3 :
                      tmp = JsxRuntime.jsx(Buhta_cabinet__KkmViewPage.make, {
                            id: id$1,
                            org: org,
                            openMenu: openMenu
                          });
                      break;
                  case /* Cashbox */4 :
                      tmp = JsxRuntime.jsx(Buhta_cabinet__CashboxPage.make, {
                            org: org,
                            id: id$1
                          });
                      break;
                  
                }
              } else {
                switch (tab.TAG | 0) {
                  case /* Settings */0 :
                      tmp = JsxRuntime.jsx(Buhta_cabinet__KkmSettingsPage.make, {
                            org: org,
                            id: id$1,
                            tab: tab._0,
                            openMenu: openMenu
                          });
                      break;
                  case /* Receipts */1 :
                      tmp = JsxRuntime.jsx(Buhta_cabinet__ReceiptsPage.make, {
                            org: org,
                            id: id$1,
                            openMenu: openMenu
                          });
                      break;
                  case /* Journal */2 :
                      tmp = JsxRuntime.jsx(Buhta_cabinet__KkmJournalPage.make, {
                            org: org,
                            id: id$1,
                            tab: tab._0,
                            openMenu: openMenu
                          });
                      break;
                  case /* Reports */3 :
                      tmp = "Страница не найдена";
                      break;
                  
                }
              }
            }
            break;
        case /* Tax */4 :
            const match$4 = route._0;
            if (typeof match$4 === "number") {
              tmp = JsxRuntime.jsx(Buhta_cabinet__TaxSettingsPage.make, {
                    org: org,
                    openMenu: openMenu
                  });
            } else if (match$4.TAG === /* Payments */0) {
              const match$5 = match$4._0;
              if (typeof match$5 === "number") {
                switch (match$5) {
                  case /* Index */0 :
                      tmp = JsxRuntime.jsx(Buhta_cabinet__TaxPaymentsPage.make, {
                            org: org,
                            openMenu: openMenu
                          });
                      break;
                  case /* Settings */1 :
                      tmp = JsxRuntime.jsx(Buhta_cabinet__TaxPaymentsSettingsPage.make, {
                            org: org,
                            openMenu: openMenu
                          });
                      break;
                  case /* New */2 :
                      tmp = "Страница не найдена";
                      break;
                  case /* Create */3 :
                      tmp = JsxRuntime.jsx(Buhta_cabinet__TaxPaymentsOrdersNewEmployeeFull.make, {
                            org: org
                          });
                      break;
                  
                }
              } else {
                switch (match$5._0) {
                  case /* Index */0 :
                      tmp = JsxRuntime.jsx(Buhta_cabinet__TaxPaymentsOrdersPage.make, {
                            org: org
                          });
                      break;
                  case /* Create */1 :
                      tmp = JsxRuntime.jsx(Buhta_cabinet__TaxPaymentsOrdersNewEmployee.make, {
                            org: org
                          });
                      break;
                  case /* Checkout */2 :
                      tmp = JsxRuntime.jsx(Buhta_cabinet__TaxPaymentsOrdersCheckout.make, {
                            org: org
                          });
                      break;
                  
                }
              }
            } else {
              tmp = "Страница не найдена";
            }
            break;
        case /* Hrm */5 :
            const id$2 = route._0._0;
            tmp = typeof id$2 === "number" ? (
                id$2 === /* Index */0 ? JsxRuntime.jsx(Buhta_cabinet__HrmEmployeesPage.make, {
                        org: org,
                        openMenu: openMenu
                      }) : JsxRuntime.jsx(Buhta_cabinet__HrmEmployeeFormPage.make, {
                        org: org,
                        openMenu: openMenu
                      })
              ) : (
                id$2.TAG === /* View */0 ? JsxRuntime.jsx(Buhta_cabinet__HrmEmployeePage.make, {
                        org: org,
                        id: id$2._0,
                        openMenu: openMenu
                      }) : JsxRuntime.jsx(Buhta_cabinet__HrmEmployeeFormPage.make, {
                        org: org,
                        id: id$2._0,
                        openMenu: openMenu
                      })
              );
            break;
        case /* Payroll */6 :
            const match$6 = route._0;
            if (match$6.TAG === /* Employees */0) {
              tmp = "Страница не найдена";
            } else {
              const id$3 = match$6._0;
              tmp = typeof id$3 === "number" ? (
                  id$3 === /* List */0 ? JsxRuntime.jsx(Buhta_cabinet__PayoutsPage.make, {
                          org: org,
                          openMenu: openMenu
                        }) : "Страница не найдена"
                ) : (
                  id$3.TAG === /* View */0 ? JsxRuntime.jsx(Buhta_cabinet__PayoutPage.make, {
                          org: org,
                          id: id$3._0
                        }) : "Страница не найдена"
                );
            }
            break;
        case /* Manage */7 :
            const match$7 = route._0;
            if (match$7) {
              const id$4 = match$7._0;
              tmp = typeof id$4 === "number" ? (
                  id$4 === /* List */0 ? JsxRuntime.jsx(Buhta_cabinet__ManageContractorsPage.make, {
                          org: org,
                          openMenu: openMenu
                        }) : JsxRuntime.jsx(Buhta_cabinet__CreateContractorPage.make, {
                          org: org
                        })
                ) : (
                  id$4.TAG === /* View */0 ? JsxRuntime.jsx(Buhta_cabinet__ViewContractorPage.make, {
                          org: org,
                          id: id$4._0
                        }) : JsxRuntime.jsx(Buhta_cabinet__UpdateContractorPage.make, {
                          org: org,
                          id: id$4._0
                        })
                );
            } else {
              tmp = JsxRuntime.jsx(Buhta_cabinet__ManageProductsPage.make, {
                    org: org
                  });
            }
            break;
        case /* Settings */8 :
            tmp = JsxRuntime.jsx(Buhta_cabinet__OrgSettingsPage.make, {
                  org: org,
                  tab: route._0
                });
            break;
        default:
          tmp = "Страница не найдена";
      }
    }
    return JsxRuntime.jsx(Buhta_cabinet__Kkm.KkmsCtx.Provider.make, Curry._3(Buhta_cabinet__Kkm.KkmsCtx.Provider.makeProps, value, JsxRuntime.jsx(Buhta_cabinet__DashboardTemplate.make, {
                        sidebar: sidebar,
                        children: tmp
                      }), undefined));
  };
}

function OrgDashboardPage(Props) {
  return make(Props.org)(Props.route);
}

const make$1 = OrgDashboardPage;

export {
  make$1 as make,
}
/* Buhta_cabinet__BatchSignPage Not a pure module */
